<template>
  <v-tabs
      grow
      v-model="selectedTab"
    >
      <v-tab
        v-for="tab in tabs"
        :key="tab"
        ripple
        @click="changeTabs(tab == 'Customer' ? 0 : 1)"
      >
        <h3>{{tab}}</h3>
      </v-tab>
      <v-tab-item
        v-for="tab in tabs"
        :key="tab"
      >  
        <v-card height="100%">
          <v-flex>
            <v-card>
              <!-- <v-text-field class="white primary--text" solo label="Search Candidate"  prepend-inner-icon="search" v-model="searchtext" clearable flat hide-details hide-no-data single-line></v-text-field> -->
              <v-text-field v-on:keyup.enter="onEnterBuyer()" :autofocus="true" class="white primary--text" solo label="Search Candidate"  prepend-inner-icon="search" v-model="searchtext" clearable flat hide-details hide-no-data single-line></v-text-field>
            </v-card>
          </v-flex>
          <div style="max-height:600px; overflow-y:scroll">
          <v-list two-line>
            <router-link tag="v-subheader"
              :to="{ 
                  name: 'BuyersInfo',
                  params: {
                    buyerId: '-1'
                  }
                }"
            >
              <v-btn class="primary--text subheading font-weight-bold" style="text-align: center;"> 
                <v-icon left dark>
                  add
                </v-icon>
                &nbsp;{{addText}}
              </v-btn>
            </router-link>
            <template v-for="(item, index) in getCandidate">
              <v-divider :key="index"/>
              <router-link tag="v-list-tile"
                :to="{ 
                  name: 'BuyersInfo',
                  params: {
                    buyerId: item['.key']
                  }
                }"
                :key="item['.key']" avatar>
                  <v-list-tile-avatar>
                  <!-- <img :src="item.avatar"> -->
                    <i class="material-icons">
                      person
                    </i>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title class="primary--text font-weight-bold">{{item.name}}</v-list-tile-title>
                    <v-list-tile-sub-title>{{item.localAddress}} , {{item.tehsil}} , {{item.district}}</v-list-tile-sub-title>
                  </v-list-tile-content>
              </router-link>
            </template>
          </v-list>
          </div>
        </v-card> 
      </v-tab-item>
  </v-tabs>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']
export default {
  data () {
    return {
      tabs: ["Customer", "Supplier"],
      selectedTab: 0,
      buyers: [],
      seller: [],
      searchtext:'',
	    isBuyerTab: true,
	    addText: 'New Customer'
    }
  },
  created () {
    this.$bindAsArray(
      'buyers',
      this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'seller',
      this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand)
    )
    console.log(this.$route.params)
    if(this.$route.params.isBuyer == 'false') {
      console.log(this.selectedTab)
      this.selectedTab = 1;
      this.isBuyerTab = false;
      this.$emit('tabSelected', index)
    }
  },
  watch: {
    selectedTab (index) {
      // this.searchtext = ''
      // if (index == 0) {
      //   this.isBuyerTab = true
      //   this.addText = 'New Buyer'
      //   this.$router.push({path: `/buyers/${-1}` })
      // } else {
      //   this.isBuyerTab = false
      //   this.addText = 'New Supplier'
      //   this.$router.push({path: `/buyers/${-1}` })
      // }
	    // this.$emit('tabSelected', index)
    },
    buyers: {
      handler(newVal, oldVal) {
        sessionStorage.removeItem("addressSuggestions")
        let addressSuggestions = [];
        newVal.map(item=>{
          if(item.localAddress && item.localAddress!="")
          addressSuggestions.push(item.localAddress);
        })
        sessionStorage.setItem("addressSuggestions",addressSuggestions)
        if(this.buyers.length && this.$route.params.buyerId) {
          let buyer = this.buyers.find(b=>b['.key'] == this.$route.params.buyerId);
          if(!buyer) {
            this.selectedTab = 1;
            this.isBuyerTab = false;
            this.$emit('tabSelected', 1)
          }
        }
      },
      deep: true,
    },
  },
  methods:{
    onEnterBuyer(){
      this.$router.push({ path: `/buyers/${this.getCandidate[0]['.key']}` });
    },
    changeTabs(index){
       this.searchtext = ''
       console.log(index)
      if (index== 0) {
        this.isBuyerTab = true
        this.addText = 'New Customer'
        this.$router.push({path: `/buyers/${-1}` })
      } else {
        this.isBuyerTab = false
        this.addText = 'New Supplier'
        this.$router.push({path: `/buyers/${-1}` })
      }
	    this.$emit('tabSelected', index)
    }
  },
  computed: {
    ...mapGlobalGetters(['selectedBrand']),
    getBuyers () {
      return  this.buyers.filter(item =>{
          if(!this.searchtext){
               return item['brand'] === this.selectedBrand
          } else{
              return (item.name && item.name.toLowerCase().includes(this.searchtext.toLowerCase()) &&  item['brand'] === this.selectedBrand) 
              ||  (item.localAddress && item.localAddress.toLowerCase().includes(this.searchtext.toLowerCase()) &&  item['brand'] === this.selectedBrand)
              ||  (item.village && item.village.toLowerCase().includes(this.searchtext.toLowerCase()) &&  item['brand'] === this.selectedBrand) 
              ||  (item.block && item.block.toLowerCase().includes(this.searchtext.toLowerCase()) &&  item['brand'] === this.selectedBrand)
              ||  (item.tehsil && item.tehsil.toLowerCase().includes(this.searchtext.toLowerCase()) &&  item['brand'] === this.selectedBrand)
              ||  (item.district && item.district.toLowerCase().includes(this.searchtext.toLowerCase()) &&  item['brand'] === this.selectedBrand);
          }           
          })    
      },
      getSeller () {
        return  this.seller.filter(item =>{
          	if(!this.searchtext){
               return item['brand'] === this.selectedBrand
          	} else{
              	return (item.name && item.name.toLowerCase().includes(this.searchtext.toLowerCase()) &&  item['brand'] === this.selectedBrand) 
              ||  (item.localAddress && item.localAddress.toLowerCase().includes(this.searchtext.toLowerCase()) &&  item['brand'] === this.selectedBrand)
              ||  (item.village && item.village.toLowerCase().includes(this.searchtext.toLowerCase()) &&  item['brand'] === this.selectedBrand) 
              ||  (item.block && item.block.toLowerCase().includes(this.searchtext.toLowerCase()) &&  item['brand'] === this.selectedBrand)
              ||  (item.tehsil && item.tehsil.toLowerCase().includes(this.searchtext.toLowerCase()) &&  item['brand'] === this.selectedBrand)
              ||  (item.district && item.district.toLowerCase().includes(this.searchtext.toLowerCase()) &&  item['brand'] === this.selectedBrand);
            }
        }) 
	},
	getCandidate () {
		if (this.isBuyerTab) {
			return this.getBuyers.sort((a, b) => {
        return a.name >= b.name ? 1 : -1;
      })
      // return this.getBuyers.reverse()
		} else {
      return this.getSeller.sort((a, b) => {
        return a.name >= b.name ? 1 : -1;
      })
			// return this.getSeller.reverse()
		}
	}
  },

  // watch: {
  //   buyers: {
  //     deep: true,
  //     handler (val) {

  //     }
  //   }
  // },
  destroyed () {
    // this.$unbind('buyers')
  }
}
</script>
<style scoped>
  .v-avatar {
    background: #15155d;
    color: white
  }
  .v-list__tile__title, .v-list__tile__sub-title{
    color: black !important;
  }
  .router-link-active {
    background: #15155d;
    color: white;
    font-weight: 600;
  }
  .router-link-active .v-avatar {
    color: #15155d !important;
    background: white !important;
  }
  .router-link-active .v-list__tile__title, .router-link-active .v-list__tile__sub-title {
    color: white !important;
  }
</style>




// WEBPACK FOOTER //
// src/components/Buyers/BuyerList/index.vue